import React from 'react';
import { createRoot } from 'react-dom/client';
import Modal from '../components/Modal/Modal';

// Crear un div para el portal del modal
let modalRootElement;
let root;

// Inicializar el modal root solo en el cliente (no en SSR)
if (typeof document !== 'undefined') {
  modalRootElement = document.getElementById('modal-root');
  
  if (!modalRootElement) {
    modalRootElement = document.createElement('div');
    modalRootElement.id = 'modal-root';
    document.body.appendChild(modalRootElement);
  }
  
  // Crear la raíz una sola vez
  root = createRoot(modalRootElement);
}

// Estado global para el modal
let modalState = {
  isOpen: false,
  error: false,
  title: { text: '', highlight: '' },
  message: '',
  confirmText: 'Confirmar',
  showConfirmButton: true,
  onConfirm: () => {},
  onClose: () => {}
};

// Función para renderizar el modal
const renderModal = () => {
  if (root) {
    root.render(
      <Modal
        isOpen={modalState.isOpen}
        onClose={modalState.onClose}
        error={modalState.error}
        title={modalState.title}
        message={modalState.message}
        confirmText={modalState.confirmText}
        showConfirmButton={modalState.showConfirmButton}
        onConfirm={modalState.onConfirm}
      />
    );
  }
};

// Función para mostrar el modal
const showModal = ({
  error = false,
  title = { text: '', highlight: '' },
  message = '',
  confirmText = 'Confirmar',
  showConfirmButton = true,
  onConfirm = () => {}
}) => {
  modalState = {
    ...modalState,
    isOpen: true,
    error,
    title,
    message,
    confirmText,
    showConfirmButton,
    onConfirm,
    onClose: () => hideModal()
  };
  renderModal();
};

// Función para ocultar el modal
const hideModal = () => {
  modalState = {
    ...modalState,
    isOpen: false
  };
  renderModal();
};

// Función para mostrar un modal de éxito
const showSuccessModal = ({
  title = { text: 'Operation ', highlight: 'successful' },
  message = 'The operation has been successfully completed.',
  confirmText = 'Accept',
  onConfirm = () => {}
}) => {
  showModal({
    error: false,
    title,
    message,
    confirmText,
    showConfirmButton: true,
    onConfirm
  });
};

// Función para mostrar un modal de error
const showErrorModal = ({
  title = { text: 'Error ', highlight: 'detected' },
  message = 'An error has occurred while processing the request.',
  confirmText = 'Understood',
  onConfirm = () => {}
}) => {
  showModal({
    error: true,
    title,
    message,
    confirmText,
    showConfirmButton: true,
    onConfirm
  });
};

// Función para mostrar un modal de respuesta (similar a showModal pero con nombre diferente)
const showResponseAlert = ({
  error = false,
  title = { text: '', highlight: '' },
  message = '',
  confirmText = 'Confirm',
  showConfirmButton = true,
  onConfirm = () => {},
  onClose = () => {}
}) => {
  modalState = {
    ...modalState,
    isOpen: true,
    error,
    title,
    message,
    confirmText,
    showConfirmButton,
    onConfirm,
    onClose: onClose || (() => hideResponseAlert())
  };
  renderModal();
};

// Función para ocultar el modal de respuesta (alias de hideModal para mantener consistencia)
const hideResponseAlert = () => {
  hideModal();
};

// Exportar las funciones
const HandleResponse = {
  showModal,
  hideModal,
  showSuccessModal,
  showErrorModal,
  showResponseAlert,
  hideResponseAlert
};

export default HandleResponse;